// @flow
import OnlineConsultation from '@screens/OnlineConsultation/index';

export default OnlineConsultation;
